// Shared bank-logo asset map for the mortgage-refinance flow.
//
// Builds { bankId: assetUrl } from files in ./assets/banks/. Each file is
// named after the source id used in sourcesConfiguration (e.g. poalim.png,
// leumi.png). Kept in its own module so both StepBankSelection (which renders
// the logos) and the connect page (which preloads them ahead of the
// bank-select step) reference the same require.context.
const bankLogosContext = require.context(
  '@/pages/responsive-pages/non-authenticated/mortgage-refinance/assets/banks',
  false,
  /\.(svg|png|jpg|jpeg)$/,
);

export const bankLogos = Object.fromEntries(
  bankLogosContext.keys().map(key => {
    const id = key.replace(/^\.\//, '').replace(/\.(svg|png|jpg|jpeg)$/, '');
    return [id, bankLogosContext(key)];
  }),
);

// Warm the browser cache for every bank logo by kicking off a fetch via the
// Image constructor. Safe to call early (e.g. when the connect page is
// created) so the logos are already cached by the time the user reaches the
// bank-select step — no blank gap on slow connections. No-op if Image is
// unavailable (SSR/tests).
export function preloadBankLogos() {
  if (typeof Image === 'undefined') { return; }
  Object.values(bankLogos).forEach(src => {
    if (!src) { return; }
    const img = new Image();
    img.src = src;
  });
}
